import React from 'react';
import { styled } from '@mui/material/styles';

const Badge = styled('span')(() => ({
  backgroundColor: '#E5EDFF', // Light blue
  color: '#2A5BD7',           // Dark blue text
  fontSize: '0.75rem',        // 12px
  fontWeight: 500,
  padding: '2px 8px',         // Rectangle shape
  borderRadius: '10px',       // Rounded corners, not a pill
  marginLeft: '8px',
  display: 'inline-block',
  lineHeight: 1.2,
  minWidth: '20px',
  textAlign: 'center',
}));

const CountBadge = ({ count }) => {
  if (!count || count <= 0) return null;
  return <Badge>{count}</Badge>;
};

export default CountBadge;
